
import { createClient } from '@supabase/supabase-js';

const getEnv = (key: string) => {
  try {
    // Check Vite env
    // Fix: Cast import.meta to any to resolve TS error: Property 'env' does not exist on type 'ImportMeta'
    if (typeof import.meta !== 'undefined' && (import.meta as any).env && (import.meta as any).env[key]) {
      return (import.meta as any).env[key];
    }
    // Check standard process.env (fallback)
    // Fix: Cast process.env to any for dynamic key access
    if (typeof process !== 'undefined' && process.env && (process.env as any)[key]) {
      return (process.env as any)[key];
    }
  } catch (e) {
    return '';
  }
  return '';
};

const supabaseUrl = getEnv('VITE_SUPABASE_URL');
const supabaseAnonKey = getEnv('VITE_SUPABASE_ANON_KEY');

export const isSupabaseConfigured = !!(supabaseUrl && supabaseAnonKey && supabaseUrl !== 'undefined');

if (!isSupabaseConfigured) {
  console.warn("CRITICAL: Supabase configuration is missing! The app will run in Mock Mode using static data.");
}

// Fallback to placeholder only if missing to prevent silent [object Object] errors later
export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co', 
  supabaseAnonKey || 'placeholder-key'
);
